export default function Footer() {
	return (
		<footer className="bg-gray-100 py-6 text-center text-gray-500 text-sm">
		©{new Date().getFullYear()} SERVINTEC. Todos los derechos reservados.
		</footer>
	);
}
